// extracted by mini-css-extract-plugin
export var caption = "by_f3";
export var grey = "by_dK";
export var heading = "by_G";
export var image = "by_g";
export var left = "by_bN";
export var reverse = "by_dG";
export var right = "by_cl";
export var section = "by_d";
export var video = "by_f4";
export var videoContainer = "by_cx";
export var videoWrapper = "by_cy";